import { render, staticRenderFns } from "./banner-slide.vue?vue&type=template&id=00544981&scoped=true&"
import script from "./banner-slide.vue?vue&type=script&lang=js&"
export * from "./banner-slide.vue?vue&type=script&lang=js&"
import style0 from "./banner-slide.vue?vue&type=style&index=0&id=00544981&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00544981",
  null
  
)

export default component.exports